import { all, call, put, take, takeLatest } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import {
  fireToastError,
  fireToastSuccess,
} from '../../actions/toasts/fireToast'
import { dataForObjectIsAccepted } from '../../actions/userObject/profile/requestFetchUserProfile'
import {
  dataObjectSaveIsRejected,
  IRequestSaveObject,
  requestSaveObjectIsAccepted,
} from '../../actions/userObject/profile/requestUpdateUserProfile'
import i18n from '../../i18n'
import { saveProfile } from '../../models/Object'
import { UserProfileActions } from '../../reducers/userObject/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* saveObjectData(action: IRequestSaveObject) {
  try {
    const actionNames = fetchActionsName(ActionNames.UpdateUserProfile)
    const [userProfile] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, saveProfile)),
    ])

    const object = yield call(userProfile.service, action.data)
    yield put(requestSaveObjectIsAccepted(action.notNotify))
    yield put(dataForObjectIsAccepted(object))
  } catch (e) {
    yield put(dataObjectSaveIsRejected(e.message))
  }
}

function* updateAccepted(action) {
  if(!action.notNotify){
    yield put(fireToastSuccess(i18n.t('user_settings_updated')))
  }
}

function* updateRejected() {
  yield put(fireToastError(i18n.t('errStatus_0')))
}

export default function* () {
  yield takeLatest(UserProfileActions.RequestSaveObject, saveObjectData)
  yield takeLatest(
    UserProfileActions.UpdatingUserProfileIsAccepted,
    updateAccepted,
  )
  yield takeLatest(
    UserProfileActions.UpdatingUserProfileIsRejected,
    updateRejected,
  )
}
